module.exports = __webpack_public_path__ + "static/media/CHAWCE_MENU-normal.452fcd56.png";